
  import '/Users/jilin/projects/antd/rc-dialog/docs/demo/ant-design.md?watch=parent';
  export const texts = [];
  